import React, { memo } from "react";
import Dialog from "./Dialog";
import { Typography } from "@mui/material";
import { Button } from "../Button";
import { useTranslation } from "react-i18next";
import { palette } from "../../../styles/theme";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
}

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      content={
        <Typography
          color={palette.grey.primary}
          sx={{ fontSize: "16px", fontWeight: 400 }}
        >
          {description}
        </Typography>
      }
      action={<Button onClick={onConfirm}>{t("general.confirm")}</Button>}
    />
  );
};

export default memo(ConfirmationDialog);
